// extracted by mini-css-extract-plugin
export default {"shell":"project-reports-page_shell__ory-v"};